module.exports = __webpack_public_path__ + "img/cropped-Favicon_CrediTú-192x192.b49d7976.png";